import { hasElementBeenEdgeTrimmed } from '../utils/has-element-been-edge-trimmed'

/**
 * VariantSelectorScript - Script for selecting and displaying the appropriate variant
 *
 * 1. retrieve the variant data from the global window object
 * 2. execute the selection logic to determine which variant to display
 * 3. make the selected variant visible with CSS
 * @param {string} renderingId - Unique ID for this instance of the renderer
 */
export const VariantSelectorScript = ({
  renderingId,
  isInline,
}: {
  renderingId: string
  isInline?: boolean
}) => {
  const htmlId = `static-variant-selector-${renderingId}`

  if (hasElementBeenEdgeTrimmed(htmlId) && !isInline) {
    return null
  }

  return (
    <script
      suppressHydrationWarning={true}
      id={htmlId}
      data-rendering-id={renderingId}
      className="static-variant-selector"
      dangerouslySetInnerHTML={{
        __html: generateVariantSelectorScript(renderingId),
      }}
    />
  )
}

const generateVariantSelectorScript = (renderingId: string): string => `
  (function() {
    try {
      const staticVariantsData = JSON.parse(document.getElementById('${renderingId}').dataset.variantsData)
      const variantId = window.__staticVariantSelector(staticVariantsData);
      window.__makeVariantVisible(variantId, '${renderingId}');
    } catch (error) {
      console.error(error, 'Critical error in static variant selector script')
    }
  })()
`
